import { getMeta, truncateString } from './helpers/main';
const locale = getMeta('locale');
const progressDiv = document.querySelector('.b-main-container__left--progress');
const handler = document.getElementById("progress-handler");
const backToFollowUp = document.querySelector('.b-link-follow_up--page');
const followUpOption = localStorage.getItem('followUpOption');
const accountName = document.querySelector('meta[name="account"]').getAttribute("content");

if (progressDiv && handler && accountName !== 'imh') {
  let stepFrom = 0;
  if (handler.dataset.stepFrom === 'r') {
    stepFrom = +handler.dataset.step + 1;
  } else if (handler.dataset.stepFrom === 'l') {
    stepFrom = +handler.dataset.step - 1;
  }

  progressDiv.animate([
    { // from
      width: `${stepFrom * 20}%`
    },
    { // to
      width: `${handler.dataset.step * 20}%`
    }
  ], {
    duration: 500,
    fill: "forwards"
  });

  if (handler.dataset.option) {
    localStorage.setItem('followUpOption', handler.dataset.option);
  }
  if (followUpOption && backToFollowUp) {
    backToFollowUp.href = `${backToFollowUp.href}&opt=${followUpOption}`;
  }
}

localStorage.setItem('locale', locale);
